import { FC } from "react";
import { Typography } from "@mui/material";
import { OutlinedPaper } from "../../../components/OutlinedPaper";
import { Skeleton } from "../../../components/loading";
import { CompanyTypeFilterChip } from "../CompanyTypeFilterChip/CompanyTypeFilterChip";

interface VendorPageHeaderProps {
  vendorName: string;
  isLoading: boolean;
}

export const VendorHeader: FC<VendorPageHeaderProps> = (props) => {
  return (
    <OutlinedPaper
      id="vendor-header-card"
      sx={{
        display: "flex",
        padding: "14px",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Skeleton isLoading={props.isLoading} width={240} height={38}>
        <Typography variant="h1" data-testid="catalog-vendor-title">
          {props.vendorName}
        </Typography>
      </Skeleton>

      <CompanyTypeFilterChip />
    </OutlinedPaper>
  );
};
